var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    attrs: {
      items: _vm.items,
      input: _vm.$emit("paymentUpdated", _vm.selectedPayment),
      label: "Payment Type",
      solo: ""
    },
    model: {
      value: _vm.paymentType,
      callback: function($$v) {
        _vm.paymentType = $$v
      },
      expression: "paymentType"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }